export type SectionName = "A" | "B" | "C" | "D" | "E";

export type GradeSectionSelection = Record<number, SectionName[]>;

export type TeacherPracticeStudent = {
  studentId: number;
  studentName: string;
  classId: number;
  section: SectionName;
};

export type TeacherPracticeSession = {
  fromTeacherDashboard: true;
  selections: GradeSectionSelection;
  students: TeacherPracticeStudent[];
  currentStudentId: number | null;
  startedAt: string;
};

export const TEACHER_PRACTICE_SESSION_KEY = "teacherPracticeSession";

export const saveTeacherPracticeSession = (
  session: TeacherPracticeSession
): void => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(TEACHER_PRACTICE_SESSION_KEY, JSON.stringify(session));
};

export const readTeacherPracticeSession = (): TeacherPracticeSession | null => {
  if (typeof window === "undefined") return null;

  const raw = sessionStorage.getItem(TEACHER_PRACTICE_SESSION_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as TeacherPracticeSession;
    if (!parsed?.fromTeacherDashboard || !Array.isArray(parsed.students)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const clearTeacherPracticeSession = (): void => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(TEACHER_PRACTICE_SESSION_KEY);
};
